import {
  BaseFlowBlockSchema,
  FlowBlockReturnTypeSchema,
  FlowBlockType,
  FlowGetNotableObjectProviderIdType,
  FlowProducedType,
} from 'flow-schema';
import { z } from 'zod';

export const GetProviderBlockConfigSchema = z
  .object({
    providerIdType: z.enum(FlowGetNotableObjectProviderIdType).optional(),
    providerId: z.string().optional(),
  })
  .refine(
    (data) => {
      return data.providerId ? data.providerIdType !== undefined : true;
    },
    {
      message: 'Provider id type is required if provider id is specified',
      path: ['providerIdType'],
    }
  );

export type GetProviderBlockConfig = z.infer<typeof GetProviderBlockConfigSchema>;

export const GetProviderBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.GetProvider),
  returnType: FlowBlockReturnTypeSchema(FlowProducedType.Provider),
  config: GetProviderBlockConfigSchema,
});

export type GetProviderBlock = z.infer<typeof GetProviderBlockSchema>;
